import React, { useEffect } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { TomiSection } from './components/TomiSection';
import { BonusSection } from './components/BonusSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type PixelFunction = ((...args: unknown[]) => void) & {
  queue: unknown[][];
  loaded: boolean;
  version: string;
};
export function App() {
  useEffect(() => {
    try {
      const pixelWindow = window as Window & {
        fbq?: PixelFunction;
        _fbq?: PixelFunction;
      };
      if (pixelWindow.fbq) return;
      const pixel = ((...args: unknown[]) => {
        pixel.queue.push(args);
      }) as PixelFunction;
      pixel.queue = [];
      pixel.loaded = true;
      pixel.version = '2.0';
      pixelWindow.fbq = pixel;
      pixelWindow._fbq = pixel;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      pixel('init', '1347508020831593');
      pixel('track', 'PageView');
    } catch {/* Pixel does not block the page. */}
  }, []);
  return <><noscript data-id="element-0" data-mp="2zm4y4lnitf2c"><img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1347508020831593&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="2zmepodo7rua5" /></noscript><main className="min-h-screen w-full bg-brand-ivory px-0 sm:py-5" data-id="element-2" data-mp="38lrp0dimj2h5"><div className="mx-auto w-full max-w-3xl overflow-hidden bg-white shadow-2xl" data-id="element-3" data-mp="38k6wetfvdtlx"><UrgencyBanner data-id="element-4" data-mp="3dlw542fmdv6u" /><Hero data-id="element-5" data-mp="3dmfqxu8e53q5" /><PainSection data-id="element-6" data-mp="3dm5ylzzvikha" /><TomiSection data-id="element-7" data-mp="3dirw8rr7mb9u" /><BonusSection data-id="element-8" data-mp="nvj4bi5joiqs" /><PricingCard data-id="element-9" data-mp="nvstj3irmlvf" /><Guarantee data-id="element-10" data-mp="nwc23tmizxws" /><Testimonials data-id="element-11" data-mp="nuhhkgf627t8" /><FAQ data-id="element-12" data-mp="nv0z3w0wmu6q" /><FinalCTA data-id="element-13" data-mp="nv0x5qhcgk43" /><Footer data-id="element-14" data-mp="nvan5e2e2r9s" /></div></main></>;
}